import { CheckCircleFilled, StopOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { ZCatalogRecordSafe } from "../../../business/records/ZCatalogRecordSafe";

export const WfStatusIcon = ({
  workflowLock,
}: {
  workflowLock: ZCatalogRecordSafe["workflowLock"];
}) => {
  if (!workflowLock) {
    return (
      <Tooltip title="Запись актуальная">
        <CheckCircleFilled style={{ color: "#22BA7A" }} />
      </Tooltip>
    );
  }
  const tooltipText = `На редактировании в рабочем потоке: «${workflowLock.workflowName}»`;
  return (
    <Tooltip title={tooltipText}>
      <StopOutlined style={{ color: "#E09D2B" }} />
    </Tooltip>
  );
};

export const sysWfStatusColumn: RtColumn<ZCatalogRecordSafe> = {
  key: "wfStatus",
  title: "Статус",
  align: "center",
  render: (row) => {
    const { workflowLock } = row;
    return <WfStatusIcon workflowLock={workflowLock} />;
  },
  width: 80,
  minWidth: 80,
};
